/**
 * Group items into a Map by derived key — the scheduler's recurring groupBy
 * shape (tasks by group id, bar rects by row index). One implementation so the
 * hand-rolled push-or-create loop isn't restated per call site.
 */
export function groupInto<K, V>(items: readonly V[], keyOf: (item: V) => K): Map<K, V[]> {
  const map = new Map<K, V[]>();
  for (const item of items) {
    const key = keyOf(item);
    const list = map.get(key);
    if (list) list.push(item);
    else map.set(key, [item]);
  }
  return map;
}
